export default __webpack_public_path__ + "static/media/ninos-Banner-Curso-Scratch-270x180.82b28aa8.png";